///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../filter-templates/active-inactive.filter.ts"/>
///<reference path="../../../common/security.keys.ts"/>
///<reference path="../collections/report-employee-categories.collection.ts"/>
///<reference path="../collections/report-employees.collection.ts"/>
///<reference path="../collection-population-strategies/employee-to-categories.strategy.ts"/>
///<reference path="report-employee-secure.ts"/>
///<reference path="../validation/reqired-if-all-unselected.validation.ts"/>


module Meevo.Components.Controls.SmartMover {


    import Dictionary = _.Dictionary;

    export class ReportEmployeeWitchCategoriesDataTemplate extends ReportSecureEmployeeDataTemplate implements ISecureDataTemplate {
        protected readonly employeeCategories: ReportEmployeeCategoriesCollection;

        get collection(): ICollectionBase<any> {
            return this.employeeCategories;
        }

        get totalSelectedCount(): number {
            return this.employees.value.length;
        }

        /**
         *
         * @param model
         * @param properties - [categoryIds, employeeIds]
         * @param options
         */
        constructor(model: Dictionary<any>, properties: string[], options: IDataTemplateOptions) {
            super(model, [properties[1]], options);
            if (typeof this.model[properties[0]] === 'undefined') {
                this.model[properties[0]] = [];
            }

            this.voidIfAllSelected = true;
            this.employeeCategories = new ReportEmployeeCategoriesCollection(this.model[properties[0]], [], { criteria: options.criteria });
            this.employees.setParentCollection(this.employeeCategories, EmployeeToCategoriesStrategy);
            this.filters = [
                new ActiveInactiveFilter({ hideInactiveLabel: 'LABEL_HIDE_INACTIVE_EMPLOYEES' }, this, false, model, "showInactiveEmployees")
            ];
            this.employees.addFilters(...this.filters as IInteractiveFilter[]);

            // by default this needs to be required because all reports have this as required and only the report scheduler does not require this field
            if (options != null && !options.required) {
                this.validation.push(
                    new RequiredIfAllUnselectedValidation(
                        this.employees,
                        () => this.smartMoverHidden,
                        'LABEL_REPORTS_SELECT_AT_LEAST_ONE_EMPL'
                    )
                );
            }
        }

        setWatchers(scope: angular.IScope) {
            this.employeeCategories.setWatchers(scope);

            super.setWatchers(scope);
        }

        onCriteriaUpdate(newCriteria: _.Dictionary<any>, $q: ng.IQService): ng.IPromise<any> {
            this.employees.updateCriteria(newCriteria);

            return this.employees.fetch();
        }
    }
}
